import { Button, Empty, Flex, Spin, Typography } from 'antd';
import { coreService } from '../../../../services/core/core-service';

import Styles from './styles';
import { useRecapManagement } from '../../../recapv2/recap-management/hook';
import { ManualClipCard } from '../ManualClipCard';
import { useQuery } from '@tanstack/react-query';
import { ManualClipsFiltersBar } from '../../../clips/components/FiltersBar';
import { useClipEventStore } from '../../store/clip.store';
import { useEffect, useState } from 'react';
import { sub } from 'date-fns';

const { Container } = Styles;

export type Clip = {
  comments: number;
  createdAt: string;
  duration: number;
  eventId: string;
  id: string;
  meetingTitle: string;
  owner: string;
  status: string;
  thumbnail: string;
  title: string;
  views: number;
};

type Filters = {
  search?: string;
  from?: Date;
  to?: Date;
};

export const ManualClipsList: React.FC = () => {
  const { id } = useRecapManagement();

  const { subscribe } = useClipEventStore();

  const [filters, setFilters] = useState<Filters>({
    search: '',
    from: sub(new Date(), { days: 7 }),
    to: new Date(),
  });

  const fromKey = filters.from ? filters.from.toISOString().split('T')[0] : undefined;
  const toKey = filters.to ? filters.to.toISOString().split('T')[0] : undefined;

  const {
    data: clips,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ['recap', 'clips', id, filters.search, fromKey, toKey],
    queryFn: () => coreService.getRecapClips(id, filters),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  useEffect(() => {
    const unsubscribe = subscribe('refreshClips', () => {
      refetch();
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <Container>
      <ManualClipsFiltersBar onChange={setFilters} />

      <div
        style={{
          marginTop: '24px',
          height: 'calc(100% - 150px)',
          overflow: 'auto',
        }}
      >
        <Flex justify="center" align="center" style={{ height: '100%' }}>
          {isFetching && <Spin />}
          {!isFetching && clips && clips.length === 0 && (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No clips were found for this recap."
            />
          )}
        </Flex>

        {!isFetching && clips && (
          <Flex gap={8} wrap>
            {clips?.map((clip: any) => (
              <ManualClipCard key={clip.id} clip={clip} showDeleteButton={clip.isOwner} />
            ))}
          </Flex>
        )}
      </div>
    </Container>
  );
};
